import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ShipmentCostListTemplate = ({
	t,
	viewStore,
	viewStore: { tableData, queryUtility, loading, showActions, data },
}) => {
	if (loading) return <Loader />;
	return (
		<div className="flex--grow--1">
			<BaasicTable
				actions={viewStore}
				data={data != null ? data.slice() : null}
				{...{ tableData, queryUtility, showActions, viewStore }}
			/>
		</div>
	);
};

export default defaultTemplate(ShipmentCostListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-cost/pages/ShipmentCostListTemplate.jsx